import 'sweetalert2/dist/sweetalert2.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/v4-shims.min.css';
import 'vue3-toastify/dist/index.css';
import 'vue-awesome-paginate/dist/style.css';
import '@tenant/theme.scss';

import tenantRoutes from '@tenant/routes';
import {tenantConfig} from '@tenant/tenant.config';

import {createTenantApp} from '@/app/createTenantApp';

createTenantApp({tenantConfig, routes: tenantRoutes});
